import { ElementType, SVGProps } from "react";
import { ResourceType } from "../../resources/types";
import { DocumentTextIcon, MusicalNoteIcon, QuestionMarkCircleIcon } from "@heroicons/react/20/solid";
import { BibleIcon } from "../icons/BibleIcon";

type Props = {
  resourceType: ResourceType
} & SVGProps<SVGSVGElement>

const ICONS: Record<ResourceType, ElementType> = {
  'Scripture': BibleIcon,
  'Song': MusicalNoteIcon,
  'Liturgy': DocumentTextIcon
};

export const ResourceTypeIcon = ({ resourceType, ...props }: Props) => {
  const Icon = ICONS[resourceType] || QuestionMarkCircleIcon;
  return (<Icon {...props} />);
};
